<template>
  <div class="app-container">
    <el-form
      ref="dataForm"
      :rules="rules"
      :model="formData"
      label-width="100px"
    >
      <!-- <el-form-item label="类型" prop="is_system">
        <el-select v-model="formData.is_system" placeholder="请选择">
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="名称" prop="name">
        <el-input v-model="formData.name" placeholder="请输入名称"></el-input>
      </el-form-item>
      <el-form-item label="数据权限" prop="data_scope">
<!--        1：全部数据权限 2：自定数据权限 3：本部门数据权限 4：本部门及以下数据权限 -->
        <el-radio-group v-model="formData.data_scope">
          <el-radio-button :label="1">全部数据权限</el-radio-button>
          <el-radio-button :label="2">个人数据权限</el-radio-button>
          <el-radio-button :label="3">本部门数据权限</el-radio-button>
          <el-radio-button :label="4">本部门及以下数据权限</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="formData.is_system === 0" label="模块">
        <el-table :data="modules" row-key="id" border default-expand-all>
          <el-table-column prop="" label="模块" width="180">
            <template slot-scope="{ row }">
              {{ row.name }}
            </template>
          </el-table-column>
          <el-table-column prop="" label="权限" :reserve-selection="true">
            <template slot-scope="{ row }">
              <el-checkbox
                v-if="row.btns && row.btns.length > 0"
                v-model="row.checkAll"
                :indeterminate="row.checkList.length > 0 && !row.checkAll"
                label="全选"
                style="margin-bottom:20px"
                @change="checkAll($event, row)"
              ></el-checkbox>
              <el-checkbox-group
                v-if="row.btns && row.btns.length > 0"
                v-model="row.checkList"
                @change="handleCheckedChange($event, row)"
              >
                <el-checkbox
                  v-for="item in row.btns"
                  :key="item.id"
                  :label="item.id"
                >{{ item.name }}</el-checkbox>
              </el-checkbox-group>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <div style="padding: 15px; text-align: center;">
      <el-button type="primary" @click="CreateData('dataForm')">提交</el-button>
      <el-button class="el-button" @click="$router.back()">返回</el-button>
    </div>
  </div>
</template>

<script>
import api from '@/api/role'
import { listMenu } from '@/api/menu'

export default {
  name: 'RoleEdit',
  components: {},
  filters: {
    getName(val) {
      const role = val.split('.')[1]
      switch (role) {
        case 'create':
          return '新增'
        case 'edit':
          return '编辑'
        case 'delete':
          return '删除'
        case 'browse':
          return '查看'
        case 'reset_password':
          return '重置密码'
        case 'reset':
          return '重置'
        case 'preview':
          return '预览'
        case 'preservation':
          return '保存'
        case 'field':
          return '管理字段'
        case 'find':
          return '查看表单填写记录'
        case 'export':
          return '导出'
        case 'import':
          return '导入'
        case 'add_custom':
          return '增加自定义数据'
        case 'app_records':
          return '查看报名记录'
        case 'batchPreview':
          return '查看答题'
        case 'score':
          return '成绩管理'
        case 'practice':
          return '练题记录'
        case 'exportpaper':
          return '导出试卷'
        case 'generatePaper':
          return '生成试卷'
        case 'clone':
          return '克隆表单'
        default:
          return ''
      }
    }
  },
  data() {
    return {
      api,
      modules: [],
      lowerLevelList: [],
      formData: {
        id: null,
        authList: [],
        is_system: 0,
        data_scope: 1
      },
      options: [
        { value: 1, label: '超级管理员' },
        { value: 0, label: '系统用户' }
      ],
      rules: {
        name: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
        is_system: [{ required: true, message: '请选择类型', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getModules().then(modules => {
      this.modules = modules
      this.formData.id = parseInt(this.$route.query.id)
      // 修改
      if (this.formData.id) {
        this.fetchData(this.formData.id)
      }
    })
  },
  methods: {
    getModules() {
      const helper = menus => {
        return menus
          .filter(i => i.status === 1 && i.show_status === 1)
          .map(menu => {
            if (menu.children) {
              if (menu.type === 'C') {
                menu.btns = helper(menu.children)
                menu.children = []
              } else if (menu.type !== 'F') {
                menu.children = helper(menu.children)
              }
            } else if (menu.type === 'C') {
              menu.btns = [menu]
            }
            this.$set(menu, 'checkAll', false)
            this.$set(menu, 'checkList', [])
            return menu
          })
      }

      return listMenu()
        .then(data => data.data)
        .then(menus => helper(menus))
    },
    CreateData() {
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          this.formData.authList = []
          this.getModuleChecked(this.modules)
          if (
            this.formData.is_system === 0 &&
            this.formData.authList.length === 0
          ) {
            this.$message.warning('请选择模块权限')
            return
          }
          console.log(this.formData)
          api.Save(this.formData).then(response => {
            this.$notify({
              title: '成功',
              message: response.message,
              type: 'success',
              duration: 2000
            })
            this.$router.back()
          })
        }
      })
    },
    checkAll(val, row) {
      if (val) {
        row.checkList = row.btns.map(i => i.id)
      } else {
        row.checkList = []
      }
    },
    getModuleChecked(modules) {
      modules.map(item => {
        if (item.checkList.length > 0) {
          this.formData.authList = this.formData.authList.concat(
            item.checkList
          )
        }
        if (item.children) {
          this.getModuleChecked(item.children)
        }
      })
    },
    setModuleChecked(modules) {
      const authMap = {}
      this.formData.authList.forEach(auth => {
        authMap[auth] = true
      })
      modules.map(item => {
        if (item.type === 'C' && item.btns) {
          item.checkList = item.btns
            .filter(i => authMap[i.id])
            .map(i => i.id)
        }
        if (item.children) {
          this.setModuleChecked(item.children)
        }
      })
    },
    handleCheckedChange(val, row) {
      row.checkAll = row.btns.length === val.length
    },
    fetchData(id) {
      api.Get(id).then(response => {
        this.formData = response.data
        if (this.formData.authList.length > 0) {
          this.setModuleChecked(this.modules)
        }
      })
    }
  }
}
</script>
